namespace AgerLMS.LMS {
    export interface LessonForm {
        Id: Serenity.IntegerEditor;
        LessonName: Serenity.StringEditor;
        DisplayOrder: Serenity.IntegerEditor;
        LessonType: Serenity.EnumEditor;
        Accessibility: Serenity.EnumEditor;
        LessonFileType: Serenity.EnumEditor;
        Volume: Serenity.DecimalEditor;
        S3FileUploadUrl: S3FileUploadEditor;
        OriginalFileUploadUrl: Serenity.ImageUploadEditor;
        OriginalFileStreamUrl: Serenity.StringEditor;
        LessonDescription: Serenity.TextAreaEditor;
        Downloadable: Serenity.BooleanEditor;
        DripContent: Serenity.BooleanEditor;
        CourseId: Serenity.LookupEditor;
        SectionId: Serenity.LookupEditor;
    }

    export class LessonForm extends Serenity.PrefixedContext {
        static formKey = 'LMS.Lesson';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LessonForm.init)  {
                LessonForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.EnumEditor;
                var w3 = s.DecimalEditor;
                var w4 = S3FileUploadEditor;
                var w5 = s.ImageUploadEditor;
                var w6 = s.TextAreaEditor;
                var w7 = s.BooleanEditor;
                var w8 = s.LookupEditor;

                Q.initFormType(LessonForm, [
                    'Id', w0,
                    'LessonName', w1,
                    'DisplayOrder', w0,
                    'LessonType', w2,
                    'Accessibility', w2,
                    'LessonFileType', w2,
                    'Volume', w3,
                    'S3FileUploadUrl', w4,
                    'OriginalFileUploadUrl', w5,
                    'OriginalFileStreamUrl', w1,
                    'LessonDescription', w6,
                    'Downloadable', w7,
                    'DripContent', w7,
                    'CourseId', w8,
                    'SectionId', w8
                ]);
            }
        }
    }
}
